import SelectRecipientsView from './SelectRecipientsView';

export default SelectRecipientsView;
